<div #xmlModal class="openFileContent">
  <div class="content">
    <button (click)="close()"><i class="fa fa-times-circle fa1x"></i></button>
    <!-- <p>{{xmlURL}}</p> -->
    <ng-template prismXML></ng-template>
    <!-- <button (click)="close()">Close</button> -->
  </div>
</div>
